<template>
  <div>
    <page-header>
      <h2>Техническая поддержка</h2>
    </page-header>

    <section class="content">
      <tech-support-card></tech-support-card>
    </section>
  </div>
</template>
<script>
import PageHeader from "@/common/components/page/PageHeader";
import TechSupportCard from "@/modules/help/components/TechSupportCard";

export default {
  name: "TechSupport",
  components: {
    PageHeader, TechSupportCard
  },
}
</script>
